import FreeTrial from '../../templates/FreeTrial/FreeTrial';
import React, { Component } from 'react';

import './styles.css';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class FreeTrialView extends Component {
	render () {
		const { content } = this.props;
		return (
			<div className='FreeTrialView'>
				<FreeTrial content={content} />
			</div>
		);
	}
}
export default withLanguageContext(FreeTrialView);



// WEBPACK FOOTER //
// ./src/components/views/FreeTrialView/FreeTrialView.js